import SelectFormItem from "./SelectFormItem";
import PriceRangeFormItem from "features/configuration/GeneralConfiguration/FormItem/PriceRangeFormItem";
import { getName } from "../utils";
import React, { CSSProperties } from "react";
import {
  PRICE_RANGE_ITEM_NAME,
  TRAILING_TYPE_ITEM_NAME,
  TRIGGER_ITEM_NAME,
} from "@shared/features/configuration/constants";
import TwoSelectorsFormItem from "features/configuration/GeneralConfiguration/FormItem/TwoSelectorsFormItem";
import { SELECT_ITEMS } from "@shared/features/tradingTerminal/common/constants";
import { SharedFormItemProps } from "@shared/features/tradingTerminal/common/types";

interface FormItemProps extends SharedFormItemProps {
  style?: CSSProperties;
}

const FormItem = ({
  item,
  orderType,
  hideBorder,
  hideTitle,
  disabled,
  style,
}: FormItemProps) => {
  const itemName = getName(item);

  const getItem = () => {
    if (
      itemName?.includes("Strategy") ||
      SELECT_ITEMS.map((item) => item?.toLowerCase()).includes(
        itemName?.toLowerCase()
      )
    ) {
      return (
        <SelectFormItem
          item={item}
          orderType={orderType}
          hideBorder={hideBorder}
          hideTitle={hideTitle}
          disabled={disabled}
        />
      );
    } else if (itemName === PRICE_RANGE_ITEM_NAME) {
      return <PriceRangeFormItem item={item} orderType={orderType} />;
    } else if (
      itemName === TRIGGER_ITEM_NAME ||
      itemName === TRAILING_TYPE_ITEM_NAME
    ) {
      return (
        <TwoSelectorsFormItem
          item={item}
          hideTitle={itemName === TRAILING_TYPE_ITEM_NAME}
        />
      );
    }
  };

  return <div style={{ ...style }}>{getItem()}</div>;
};

export default FormItem;
